import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "FhcMainLinksTile": {
        meta: {
            i18nDescrKey: "main-links-tile",
            pinnable: true,
            tag: 'FHC_OVERVIEW'
        },
        component: () => import("./components/tiles/FhcMainLinksTile.vue")
    },
    "FhcProcessesToCompleteTile": {
        meta: {
            i18nDescrKey: "processes-to-complete-tile",
            pinnable: true,
            tag: 'FHC_OVERVIEW',
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"]
        },
        component: () => import("./components/tiles/FhcProcessesToCompleteTile.vue")
    },
    "FhcProcessesTimelineTile": {
        meta: {
            i18nDescrKey: "processes-timeline-tile",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: 'FHC_OVERVIEW'
        },
        component: () => import("./components/tiles/FhcProcessesTimelineTile.vue")
    },
    "FhcPlannedActivitiesTile": {
        meta: {
            i18nDescrKey: "planned-activities-tile",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: 'FHC_OVERVIEW'
        },
        component: () => import("./components/tiles/FhcPlannedActivitiesTile.vue")
    }
};

export default globals;
